import React from 'react'

const ExternalLink = ({to, children, className}) => {
  return to
    ? <a href={to} className={className} target='_blank' rel='noopener noreferrer'>{children || to}</a>
    : null
}

export default ExternalLink
